import { Text, View } from '@react-pdf/renderer';
import nls from '../../../nls/pt-BR.json';
import { DefaultLayoutFormValue } from '../../../redux/studies.model';
import { headerStyles as styles } from './styles';

const dictionary = nls.pdfReport;

interface FrontPageHeaderProps {
  headerInfo: {
    studyName: string;
    creationDate: string;
    id: string;
  };
}

export const FrontPageHeader: React.FC<FrontPageHeaderProps> = ({
  headerInfo,
}) => {
  const { studyName, creationDate, id } = headerInfo;

  return (
    <View style={[styles.header, { height: 111 }]}>
      <Text style={styles.title}>{dictionary.title}</Text>
      <Text style={styles.sectionTitle}>{studyName}</Text>
      <View style={styles.characteristicsContainer}>
        <Text>
          {dictionary.date}: {creationDate}
        </Text>
      </View>
    </View>
  );
};

export interface BuildingLayoutDataHeaderProps {
  layoutNumber: string;
  characteristics: Omit<DefaultLayoutFormValue, 'id'>;
}

export const BuildingLayoutDataHeader: React.FC<
  BuildingLayoutDataHeaderProps
> = ({ layoutNumber, characteristics }) => {
  const values = Object.values(characteristics);
  return (
    <View style={[styles.header, { height: 126 }]}>
      <Text style={styles.title}>{dictionary.title}</Text>
      <Text style={styles.sectionTitle}>
        {dictionary.layoutNumber} {layoutNumber}
      </Text>
      <Text>
        <View style={styles.characteristicsContainer}>
          <Text>{dictionary.characteristics}: </Text>
          <Text>{values[0]}, </Text>
          <Text>{values[1]}m², </Text>
          <Text>{values[2]} dorm, </Text>
          <Text>{values[3]} s, </Text>
          <Text>{values[4]} g</Text>
        </View>
      </Text>
    </View>
  );
};
